/**
 * themes
 *
 * Preset gradient themes for the public survey, reused in create-campaign.
 */
export const themes = {
  sunset: {
    background: 'bg-gradient-to-br from-orange-500 via-pink-500 to-purple-600',
    text: 'text-white',
    subtext: 'text-orange-100',
    border: 'border-white/20',
    input: 'bg-white/20',
    name: 'Sunset Vibes'
  },
  midnight: {
    background: 'bg-gradient-to-br from-gray-900 via-primary-900 to-gray-900',
    text: 'text-white',
    subtext: 'text-primary-200',
    border: 'border-primary-900/50',
    input: 'bg-primary-950/50',
    name: 'Midnight primary'
  },
  nature: {
    background: 'bg-gradient-to-br from-green-400 via-emerald-500 to-teal-600',
    text: 'text-white',
    subtext: 'text-emerald-100',
    border: 'border-white/20',
    input: 'bg-white/20',
    name: 'Nature Fresh'
  },
  ocean: {
    background: 'bg-gradient-to-br from-cyan-500 via-primary-500 to-primary-600',
    text: 'text-white',
    subtext: 'text-cyan-100',
    border: 'border-white/20',
    input: 'bg-white/20',
    name: 'Ocean Depths'
  },
  aurora: {
    background: 'bg-gradient-to-br from-teal-400 via-purple-500 to-pink-500',
    text: 'text-white',
    subtext: 'text-teal-100',
    border: 'border-white/20',
    input: 'bg-white/20',
    name: 'Aurora Lights'
  },
  desert: {
    background: 'bg-gradient-to-br from-amber-500 via-red-500 to-rose-600',
    text: 'text-white',
    subtext: 'text-amber-100',
    border: 'border-white/20',
    input: 'bg-white/20',
    name: 'Desert Sands'
  }
};